import { render, staticRenderFns } from "./GenericUserFilter.vue?vue&type=template&id=78b25a94&scoped=true&"
import script from "./GenericUserFilter.vue?vue&type=script&lang=js&"
export * from "./GenericUserFilter.vue?vue&type=script&lang=js&"
import style0 from "./GenericUserFilter.vue?vue&type=style&index=0&id=78b25a94&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b25a94",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib'
installComponents(component, {VChip})
